import { Component } from '@angular/core';

@Component({
  selector: 'greco-video-sending-dialog',
  templateUrl: './video-sending-dialog.dialog.html',
  styleUrls: ['./video-sending-dialog.dialog.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class VideoSendingDialog {}
